export const parseHighlights = (hash: string): Set<number> => {
  const nums = new Set<number>();
  if (!hash || !hash.startsWith("#")) return nums;
  const fragment = hash.slice(1);
  const parts = fragment.split(",");
  for (const part of parts) {
    const trimmed = part.trim();
    const rangeMatch = trimmed.match(/^L(\d+)-L(\d+)$/i);
    if (rangeMatch) {
      const start = parseInt(rangeMatch[1], 10);
      const end = parseInt(rangeMatch[2], 10);
      for (let i = start; i <= end; i++) nums.add(i);
      continue;
    }
    const singleMatch = trimmed.match(/^L(\d+)$/i);
    if (singleMatch) {
      nums.add(parseInt(singleMatch[1], 10));
    }
  }
  return nums;
};
